import { GeneralReportStore} from "Reports";

export abstract class tps {
    private static reportStore:  GeneralReportStore;
    static reportConfiguration(reportStore: GeneralReportStore) {
        tps.reportStore = reportStore;
    }
    static getReportSettings() {
        const reportSettings = tps.reportStore.toReportConfiguration();
        return {
            Tiles: reportSettings.tiles.slice(),
            UnitSystem: reportSettings.units,
            InstructorMessage: reportSettings.instructorMessage,
            ReportSelection: reportSettings.reportSelection,
            OptimizerOn: reportSettings.optimizerOn,
            SkidAndRollOn: reportSettings.skidAndRollOn,
            DispersionOn: reportSettings.dispersionOn,
            TrajectoryOn: reportSettings.trajectoryOn,
            VideoOn: reportSettings.videoOn,
            ClubDataOn: reportSettings.clubDataOn,
            SummaryOn: reportSettings.summaryOn,
            SelectedDispersionMode: reportSettings.selectedDispersionMode,
            ShowNormalizedData: reportSettings.showNormalizedData,
            SelectedOptimizedType: reportSettings.selectedOptimizedType,
            SelectedOptimizerView: reportSettings.selectedOptimizerView,
            SelectedView: reportSettings.selectedView,
            SelectedStroke: reportSettings.selectedStroke,
            SelectedStrokesGroups: reportSettings.selectedStrokesGroups,
            SelectedGroupOfStrokes: reportSettings.selectedGroupOfStrokes,
            SelectedClubType: reportSettings.selectedClubType,
            HiddenShots: reportSettings.hiddenShots,
            SelectedVideoAngles: reportSettings.selectedVideoAngles,
            ShowBottomCommercial: reportSettings.showBottomCommercial
        }
    }
}

(window as any)["tps"] = tps;


